export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/5860effcda061f4f05feb4a92be5a34c.svg";